var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"privacy-container"},[(_vm.loading)?_c('div',{staticClass:"loading-box"},[_c('el-spinner',{attrs:{"size":"40"}}),_vm._v(" "),_c('p',[_vm._v("政策内容加载中...")])],1):(_vm.htmlContent)?_c('div',{staticClass:"policy-content",domProps:{"innerHTML":_vm._s(_vm.htmlContent)}}):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-649f6090","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/privacyPolicy.vue
// module id = null
// module chunks = 